import { getConditionalObject } from 'utils/data';

export const getEmptySupportingDocument = vendorDocType => ({
  documentType: null,
  ...getConditionalObject(!!vendorDocType, () => ({ [vendorDocType.key]: null })),
});
